import { useCallback } from 'react'

import {
  type FPlusExpressionValue,
  isNotRelevantField,
  type SubTemplateFieldValue,
} from '../../types/templateModel'
import { createLiteralTypeInformation } from '../fplusExpression/expressionType'
import { updateVariant } from '../templateDetails/content/helpers'
import { TemplateFieldExpression } from '../templateFieldExpression/TemplateFieldExpression'

type Props = {
  variant: SubTemplateFieldValue
}

export const SubTemplatedFieldValueDefaultSelected = ({ variant }: Props) => {
  const handleChanged = useCallback(
    (nextValue: FPlusExpressionValue) =>
      updateVariant({
        variant,
        property: 'defaultSelected',
        value: nextValue,
      }),
    [variant],
  )

  return (
    <div className="flex size-full">
      <TemplateFieldExpression
        expression={variant.defaultSelected?.expression}
        path={`${variant.path}.defaultSelected`}
        fallbackCode=""
        typeInformation={createLiteralTypeInformation({
          literalType: 'boolean',
          source: variant.defaultSelected?.expression?.fplusSource,
        })}
        onChange={
          isNotRelevantField(variant.subTemplatedField)
            ? undefined
            : handleChanged
        }
        fromOrigin={variant.defaultSelected?.origin}
      />
    </div>
  )
}
